// extracted by mini-css-extract-plugin
module.exports =  {"success_border":"MessageSuccess-module__success_border___S7tbx"};